import { render } from "./favorite.vue?vue&type=template&id=233c5e2e&scoped=true"
import script from "./favorite.vue?vue&type=script&lang=js"
export * from "./favorite.vue?vue&type=script&lang=js"

import "./favorite.vue?vue&type=style&index=0&id=233c5e2e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233c5e2e"]])

export default __exports__